
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/digital-customer-journey",
      function () {
        return require("private-next-pages/solutions/digital-customer-journey/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/digital-customer-journey"])
      });
    }
  